import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Box, Button, List, ListItem, SimpleGrid, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {MinusIcon, PlusIcon} from '../icons'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

// Single markup for both breakpoints: below `lg` columns behave as an accordion,
// from `lg` up they are always expanded and the toggle button is replaced by a heading.
const StandardLinks = ({linkGroupSchema}) => {
    const styles = useMultiStyleConfig('Footer')
    const listStyles = useMultiStyleConfig('LinksList', {variant: 'vertical'})
    const {buildUrl} = useMultiSite()
    const [openItems, setOpenItems] = useState([])

    const toggle = (index) =>
        setOpenItems((prev) =>
            prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
        )

    return (
        <Box {...styles.standardLinkContainer} data-testid="link-column">
            <SimpleGrid {...styles.standardLinkGrid}>
                {linkGroupSchema.map(({column_title = '', links = []}, index) => {
                    const isOpen = openItems.includes(index)
                    const validLinks = links?.filter((item) => item.link?.title && item.link?.href)

                    return (
                        <Box
                            key={index}
                            {...listStyles.containerLinks}
                            {...styles.standardLinkColumn}
                        >
                            {column_title && (
                                <>
                                    <Text {...listStyles.heading} {...styles.standardLinkHeading}>
                                        {column_title}
                                    </Text>
                                    <Box
                                        as="button"
                                        type="button"
                                        aria-expanded={isOpen}
                                        onClick={() => toggle(index)}
                                        {...styles.accordionButton}
                                        {...styles.standardLinkToggle}
                                    >
                                        <Text {...styles.accordionHeading}>{column_title}</Text>
                                        <Box
                                            {...styles.accordionIconContainer}
                                            transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
                                            transition="transform 0.3s ease"
                                            {...styles.accordionIcon}
                                        >
                                            {isOpen ? (
                                                <MinusIcon {...styles.accordionIcon} />
                                            ) : (
                                                <PlusIcon {...styles.accordionIcon} />
                                            )}
                                        </Box>
                                    </Box>
                                </>
                            )}

                            <Box
                                display="grid"
                                gridTemplateRows={{base: isOpen ? '1fr' : '0fr', lg: '1fr'}}
                                visibility={{base: isOpen ? 'visible' : 'hidden', lg: 'visible'}}
                                transition="grid-template-rows 0.3s ease, visibility 0.3s ease"
                                {...(isOpen ? {marginTop: 'xsmall.md'} : {})}
                            >
                                <List
                                    {...listStyles.list}
                                    {...styles.standardLinkList}
                                    display="flex"
                                    minH={0}
                                    overflow="hidden"
                                >
                                    {validLinks.map(({link, is_external_url}, linkIndex) => {
                                        const isExternalUrl = !!is_external_url
                                        return (
                                            <ListItem key={linkIndex} {...styles.standardLinkItem}>
                                                <Button
                                                    as="a"
                                                    variant="link-button-no-underline"
                                                    size="base"
                                                    isExternal={isExternalUrl}
                                                    href={
                                                        isExternalUrl
                                                            ? link.href
                                                            : buildUrl(link.href)
                                                    }
                                                    {...styles.policies}
                                                >
                                                    {link.title}
                                                </Button>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </Box>
                        </Box>
                    )
                })}
            </SimpleGrid>
        </Box>
    )
}

StandardLinks.propTypes = {
    linkGroupSchema: PropTypes.array.isRequired,
}
export default StandardLinks
